import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React, { useCallback, useState } from 'react';

import ControlPropertiesUpdate from './ControlPropertiesUpdate';
import ControlPropertiesValidation from './ControlPropertiesValidation';
import { PropertyComponentModal } from '../PropertyComponentModal/PropertyComponentModal';

const useStyles = makeStyles({
  gridWrapper: {
    '& div table[class*="MuiTable-root"]': {
      overflowX: 'hidden',
      border: 'solid 1px #e9e9e9',
    },
  },
});

const ControlPropertiesValidationUpdate = ({ controlId, label }) => {
  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [currentModal, setCurrentModal] = useState('');

  const handleClick = useCallback((type) => {
    setOpenModal(true);
    setCurrentModal(type);
  }, []);

  return (
    <Grid
      container
      spacing={2}
      classes={{
        root: classes.gridWrapper,
      }}
    >
      <ControlPropertiesValidation controlId={controlId} handleClick={handleClick} />
      <ControlPropertiesUpdate controlId={controlId} handleClick={handleClick} />
      {openModal && (
        <PropertyComponentModal
          open={openModal}
          label={label}
          onClose={() => setOpenModal(false)}
          controlId={controlId}
          name={currentModal}
        />
      )}
    </Grid>
  );
};

export default ControlPropertiesValidationUpdate;
